import { Stack, TextField } from '@mui/material';
import QuestionField from '../components/QuestionField';
import ChoiceGroup from '../components/ChoiceGroup';
import SelectInput from '../components/SelectInput';
import ConditionalBranch from '../components/ConditionalBranch';
import StepFooter from '../components/StepFooter';
import { EMBARGO_PERIOD, POST_EMBARGO_ACCESS } from '../../registryChoices';

const ANONYMOUS_OPTIONS = [
  { value: true, label: 'Yes, please share anonymously' },
  { value: false, label: "No, share my organization's name" },
];

const Step6WrapUp = ({ formData, setField, showErrors, onSubmit, onBack, saving }) => {
  const isShared = formData.post_embargo_access !== 'none';
  const anonymousMissing = showErrors && isShared && formData.anonymous === null;
  const isByRequest = formData.post_embargo_access === 'by_request';

  return (
    <>
      <Stack spacing={3.25}>
        <QuestionField
          label="Is there any additional information you would like to share with us about your experiment?"
          helper="Please note here, for example, if there are any other experiments that you are submitting that use the same creatives in the same electoral context."
        >
          <TextField
            hiddenLabel
            fullWidth
            multiline
            minRows={3}
            value={formData.notes}
            onChange={(e) => setField('notes', e.target.value)}
          />
        </QuestionField>

        <QuestionField
          label="Please select when this pre-registration's embargo will end."
          required
          helper="(i.e., until then, it's not visible to anyone outside your organization and the Analyst Institute)"
        >
          <SelectInput
            options={EMBARGO_PERIOD}
            value={formData.embargo_period}
            onChange={(v) => setField('embargo_period', v)}
          />
        </QuestionField>

        <QuestionField
          label="Who should have access to your pre-registration?"
          required
          helper={
            isByRequest
              ? 'Once the embargo date has passed, the Analyst Institute grants access to the specific organizations it shares your pre-registration with.'
              : 'Once the embargo date has passed, your pre-registration will be available for other platform users to view.'
          }
        >
          <SelectInput
            options={POST_EMBARGO_ACCESS}
            value={formData.post_embargo_access}
            onChange={(v) => setField('post_embargo_access', v)}
          />
        </QuestionField>
        {isShared && (
          <ConditionalBranch>
            <QuestionField
              label="Would you like your organization to remain anonymous?"
              required
              helper="If you select anonymous, when your study is shared, it will be shared without your organization's name."
              error={anonymousMissing ? 'This question is required.' : ''}
            >
              <ChoiceGroup
                options={ANONYMOUS_OPTIONS}
                value={formData.anonymous}
                onChange={(v) => setField('anonymous', v)}
              />
            </QuestionField>
          </ConditionalBranch>
        )}
      </Stack>

      <StepFooter onBack={onBack} onNext={onSubmit} nextLabel="Submit Registration" nextDisabled={saving} />
    </>
  );
};

export default Step6WrapUp;
